import React, { useState } from 'react';
import { Delete, FileOpen } from '@mui/icons-material';
import { type DocumentBoxProps } from './types';
import { PAGE_TEXT } from '../../pages/Nomination/components/lang';
import { downloadFile } from '../../utils';
import { useAuth } from '../../contexts';
import { Alert, type AlertDetails } from '../Alert';

export const DocumentBox: React.FunctionComponent<DocumentBoxProps> = (
  props: DocumentBoxProps,
) => {
  const { file, handleRemoveFile } = props;
  const isEditable = handleRemoveFile !== undefined;
  const { handleLoading } = useAuth();

  const [openAlert, setOpenAlert] = useState(false);
  const [alertDetails, setAlertDetails] = useState<AlertDetails>({
    alertContent: '',
    alertType: 'error',
  });

  const removeFile = (): void => {
    if (handleRemoveFile) {
      handleRemoveFile(file);
    }
  };

  const handleDownLoadFile = async (): Promise<void> => {
    await handleLoading(async () => {
      try {
        await downloadFile(file.id, 'pdf', file.name);
      } catch (error) {
        setOpenAlert(true);
        setAlertDetails({
          alertType: 'warning',
          alertContent: 'Error Occurs.' + (error as Error)?.message,
        });
      }
    });
  };

  return (
    <>
      <Alert
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertDetails={alertDetails}
      />

      <div className="flex item-center mb-4">
        <div
          className="icon-wrapper cursor-pointer"
          style={{
            marginRight: '1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={handleDownLoadFile}
        >
          <FileOpen className="text-[#951d1d]" />
        </div>
        <div className="text-[#8C8C8C] mr-auto pt-[0.25rem] text-sm">
          {file?.name}
        </div>
        {isEditable && (
          <div
            className="flex items-center cursor-pointer text-[#951D1D]"
            onClick={removeFile}
          >
            <Delete className="text-[#951D1D]" />
            <span>{PAGE_TEXT.REMOVE}</span>
          </div>
        )}
      </div>
    </>
  );
};
